import { useEffect, useState } from 'preact/hooks';
import { api } from '../api';
import type { T } from '../i18n';
import { deviceCountry } from '../region';
import { GoogleMark } from './Icons';

type Options = { google: boolean; devUsers: string[] };

/**
 * Signed-out landing page. Google is the only way in on a real deploy; a local
 * development server also offers the seeded test users.
 */
export function Login({ t, failed }: { t: T; failed: boolean }) {
  const [options, setOptions] = useState<Options | null>(null);
  const [devError, setDevError] = useState(false);

  useEffect(() => {
    api
      .authOptions()
      .then(setOptions)
      .catch(() => setOptions({ google: true, devUsers: [] }));
  }, []);

  const signInAs = async (handle: string) => {
    try {
      await api.devLogin(handle);
      window.location.reload();
    } catch {
      setDevError(true);
    }
  };

  return (
    <div class="login">
      <img class="login-logo" src="/assets/logo2.png" alt="Qué fue, pana?" />
      <div class="login-title">QUÉ FUE, PANA?</div>
      <div class="kicker">{t('loginTagline')}</div>
      <p class="login-body">{t('loginBody')}</p>
      {(failed || devError) && <div class="empty login-error">{t('signInFailed')}</div>}

      {(options?.google ?? true) && (
        <a class="google-btn" href={`/auth/google/start?country=${encodeURIComponent(deviceCountry())}`}>
          <GoogleMark />
          <span>{t('signInGoogle')}</span>
        </a>
      )}

      {!!options?.devUsers.length && (
        <div class="dev-login">
          <div class="kicker">{t('devOnly')}</div>
          <div class="dev-users">
            {options.devUsers.map((handle) => (
              <button key={handle} class="btn-line dev-user" onClick={() => void signInAs(handle)}>
                {handle}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
